import { render } from "./FeedbackBr.vue?vue&type=template&id=6afca832&scoped=true"
import script from "./FeedbackBr.vue?vue&type=script&lang=js"
export * from "./FeedbackBr.vue?vue&type=script&lang=js"

import "./FeedbackBr.vue?vue&type=style&index=0&id=6afca832&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afca832"]])

export default __exports__